import SiriusSteps, { SiriusStepsProps as StepsProps } from './siriusSteps';
export { SiriusSteps };
const Steps = SiriusSteps;
export default Steps;
